/**
 * Email Subscription Server Actions
 * Handle newsletter/CTA email submissions
 */

'use server';

import { revalidatePath } from 'next/cache';

/**
 * Subscribe email to newsletter
 */
export async function subscribeEmail(email: string, sectionKey: string) {
  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { data: null, error: 'Invalid email address' };
  }

  // In a static site, we don't have a DB to save to.
  // We could use an external service here if needed.
  console.log(`Subscription request: ${email} for ${sectionKey}`);

  revalidatePath('/blogs');
  revalidatePath('/blogs/[slug]');

  return { data: { email, section_key: sectionKey }, error: null };
}
